import wxSdk from 'weixin-js-sdk' // h5分享用到
import {getSignPackage} from '@/service/wechat' // 分享接口后台提供，用于获取appid，timestamp，nonceStr，signature
import {wechatMatchMobile} from './common'

const Shares = {
  // h5分享功能
  initRealAuthUrl() {
    // todo 兼容  ios 进入首页后 realAuthUrl 不变化， 在app.vue  缓存首次进入路由 window.entryUrl
    if (typeof window.entryUrl === 'undefined' || window.entryUrl === '') {
      window.entryUrl = window.location.href.split('#')[0]
    }
  },
  clearRealAuthUrl() {
    if (typeof window.entryUrl !== 'undefined' || window.entryUrl) {
      window.entryUrl = ''
    }
  },
  shareCode: async function ({imgUrl, title, desc, link, callback}) {
    // todo 只有移动端才注册这个
    if (!wechatMatchMobile()) {
      console.log("不是微信公众号内")
      return
    }
    // 兼容了  ios 进入首页后 realAuthUrl 不变化， 在app.vue  缓存首次进入路由 window.entryUrl
    let signLink = /(Android)/i.test(navigator.userAgent) ? window.location.href : window.entryUrl
    if (encodeURIComponent(signLink) == 'undefined') {
      signLink = window.location.href
    }
    const res = await getSignPackage({url: signLink})
    //{"code":"0","msg":"成功","app_id":"wx39a09f23e4345446","timestamp":1689236113,"nonce_str":"HfQh5Votdpt7xX3I","signature":"cdbfae9e8d62426ac3b715a94252cbe09eda6f75"}
    wxSdk.config({
      debug: false, // 用来调试
      appId: res.app_id, // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.nonce_str, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名
      // jsApiList: ["updateAppMessageShareData"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      jsApiList: [
        'updateAppMessageShareData'
      ],
    })
    wxSdk.ready(function () {
      wxSdk.checkJsApi({
        jsApiList: ['updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          console.log('wxSdk.checkJsApi 以键值对的形式返回，可用的api值true，不可用为false 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}')
          console.log(`wxSdk.checkJsApi updateAppMessageShareData    结果`, res);
        },
      })

      // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
      wxSdk.updateAppMessageShareData({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        success: function (res) {
          console.log('updateAppMessageShareData success 用户确认分享后执行的回调函数', res)
        },
        cancel: function () {
          console.log('updateAppMessageShareData cancel 用户取消分享后执行的回调函数')
        },
      })
    })

    //  异常失败
    wxSdk.error(function (res) {
      console.log('wxSdk.error 失败', res)
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    });
  },
}
export {Shares}
